__turbopack_context__.v({
  "button": "submit-module-scss-module__dYzkfq__button",
  "disclaimer": "submit-module-scss-module__dYzkfq__disclaimer",
  "disclaimer-medium": "submit-module-scss-module__dYzkfq__disclaimer-medium",
  "disclaimer-small": "submit-module-scss-module__dYzkfq__disclaimer-small",
  "submit": "submit-module-scss-module__dYzkfq__submit",
});
